import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';

@Injectable({
    providedIn: 'root',
})
export class ToastService {
    constructor(private toastCtrl: ToastController) {}

    public create(
        message: string,
        duration: number = 2000,
        position: 'top' | 'middle' | 'bottom' = 'top',
        showCloseButton: boolean = false,
    ) {
        const options = {
            message: message,
            duration: duration,
            position: position,
            cssClass: 'toast-mess',
        };
        return this.toastCtrl.create(options);
    }

    async toast(
        message: string,
        duration: number = 2000,
        position: 'top' | 'middle' | 'bottom' = 'top',
        showCloseButton: boolean = false,
    ): Promise<void> {
        const toast = await this.create(message, duration, position, showCloseButton);
        toast.present();
    }
}
